<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    elementType?: string;
    isOpen?: boolean;
    noBorder?: boolean;
  }>(),
  {
    elementType: 'div',
    isOpen: false,
    noBorder: false,
  },
);

const emit = defineEmits<{
  (e: 'toggle', payload: { state: boolean }): void;
}>();

const toggleIconClass = computed(() =>
  props.isOpen ? 'fa-angle-down' : 'fa-angle-right',
);

const cardClass = computed(() => {
  const result: Record<string, boolean> = {
    'itp-accordion': true,
    'itp-accordion--open': props.isOpen,
    shadow: !!props.isOpen,
    'list-group-item': props.elementType.toLowerCase() === 'li',
    card: props.elementType.toLowerCase() === 'div',
  };

  return result;
});

function toggle() {
  emit('toggle', { state: !props.isOpen });
}
</script>

<template>
  <component :is="elementType" :class="cardClass">
    <div class="card-header d-flex align-items-center bg-white border-bottom-0">
      <div class="w-100">
        <slot name="header"></slot>
      </div>

      <ItpButton :icon="toggleIconClass" variant="light" @click="toggle" />
    </div>

    <div class="card-body" v-if="isOpen">
      <slot></slot>
    </div>
  </component>
</template>

